import {
  FilterOptions,
  PriceDataResponse,
  PriceProcessingData,
  PriceProcessingFiltersForRTK,
  PriceProcessingResponse,
  SavePriceChangesRequest,
  SavePriceChangesResponse
} from '@/types/price-processing.types';
import { ApiResponse } from '@/types/services';

import { baseApi } from './base-api';
import { buildQueryParams } from './helpers';

export type GetPriceProcessingFiltersResponse = ApiResponse<FilterOptions>;
export type GetPriceProcessingDataResponse = ApiResponse<PriceDataResponse>;

export const priceProcessingApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getPriceProcessingFilters: builder.query<FilterOptions, PriceProcessingFiltersForRTK>({
      query: filters => {
        const queryString = buildQueryParams(filters);
        return { url: `price-processing/filters${queryString ? `?${queryString}` : ''}` };
      },
      providesTags: ['PriceProcessingFilters'],
      transformResponse: (response: GetPriceProcessingFiltersResponse): FilterOptions => {
        return response.data;
      }
    }),
    getPriceProcessingData: builder.query<PriceProcessingData, PriceProcessingFiltersForRTK>({
      query: filters => {
        const queryString = buildQueryParams(filters);
        return { url: `price-processing/data${queryString ? `?${queryString}` : ''}` };
      },
      providesTags: ['PriceProcessingData'],
      transformResponse: (response: GetPriceProcessingDataResponse): PriceProcessingData => {
        const { data } = response;
        const globalData = data.global.map(item => ({
          brand_id: item.brand_id,
          region: item.region || 'Global',
          province: item.province || 'All',
          brand: item.brand,
          address: item.province || 'All',
          lastUpdate: item.last_price_change_date || '',
          prices: item.fuel_prices || {},
          changeDate: item.last_price_change_date || '',
          isOkko: item.is_reference === true || item.brand === 'ОККО',
          isEditable: true
        }));

        const stationData = data.stations.map(item => ({
          station_unicode: item.unicode,
          brand_id: item.brand_id,
          region: item.region,
          province: item.province,
          brand: item.brand,
          address: item.address,
          lastUpdate: item.last_price_change_date || '',
          prices: item.fuel_prices || {},
          changeDate: item.last_price_change_date || '',
          isOkko: item.is_reference === true || item.brand === 'ОККО',
          isEditable: true,
          binded: item.binded === true,
          binded_to: item.binded_to,
          is_reference: item.is_reference === true,
          unicode: item.unicode
        }));
        return {
          global: globalData,
          stations: stationData
        };
      }
    }),
    savePriceChanges: builder.mutation<PriceProcessingResponse, SavePriceChangesRequest>({
      query: saveData => ({
        url: 'price-processing/save-price-changes',
        method: 'POST',
        body: saveData
      }),
      invalidatesTags: ['PriceProcessingData'],
      transformResponse: (responseData: SavePriceChangesResponse): PriceProcessingResponse => {
        return {
          message: responseData.data?.message || responseData.message || 'Ціни успішно збережено',
          processed_count: responseData.data?.processedRecords || 0,
          scheduledNotifications: responseData.data?.scheduledNotifications
        } as PriceProcessingResponse;
      }
    })
  })
});
export const { useGetPriceProcessingFiltersQuery, useGetPriceProcessingDataQuery, useSavePriceChangesMutation } =
  priceProcessingApi;
